var scope_0 = require('/usr/src/app/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7bc93bd9e8730ef687ce4060b0bb2729.js').default;
var scope_1 = require('/usr/src/app/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ca117f60640dcdd9304ce4af0031d61a.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    